/**
 * Component gut-services-featured-items JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */

jQuery(document).ready(function () {
    const component = jQuery('.gut-services-featured-items');

    if (!component.length) {
        return;
    }

    jQuery('.gut-services-featured-items .gut-services-featured-items__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        //
        dots: true,
        //
        arrows: true,
        prevArrow: jQuery('.gut-services-featured-items__top-arrows-prev a'),
        nextArrow: jQuery('.gut-services-featured-items__top-arrows-next a'),
        //
        infinite: true,
        autoplay: false,
        //
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
        ]
    });
});